import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { formatSplitKey } from "../../../commons/FormatValue";
import {
  addEditServiceRequest,
  getServiceRequest
} from "../../../commons/ServiceRequest";
import BindingForm from "../../../components/PMWork/BindContract/BindingForm";
import CustContractItemsService from "../../../services/custcontractitem.service";
import CusBranchsService from "../../../services/cusbranch.service";
import BindContractBranchForm from "../../../components/PMWork/BindContract/BindContractBranchForm";
import BranchSerialNumberForm from "../../../components/PMWork/BindContract/BranchSerialNumberForm";
import ProdSetMcsService from "../../../services/prodsetmc.service";
import DetermineAgeForm from "../../../components/PMWork/BindContract/DetermineAgeForm";
import DefineAgeEquipsService from "../../../services/defineageequips.service";
import StickerDateForm from "../../../components/PMWork/BindContract/StickerDateForm";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";

export default function EditBindingPMServiceContract() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [editData, setEditData] = useState(null);

  const handleChangeTab = (key) => {
    if (["age", "sticker"].includes(state?.type)) key = `${key}.${state?.type}`;

    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        binding: "แก้ไขรายการสินค้าในสัญญา",
        branch: "แก้ไขสินค้าให้สาขา",
        machine: "แก้ไขหมายเลขเครื่องประจำสาขาและเพิ่มรายละเอียดอื่นๆ",
        determine: {
          age: "แก้ไขข้อมูลอายุอุปกรณ์/อะไหล่",
          sticker: "แก้ไขข้อมูล Sticker Date"
        }
      }
    });

    const serviceRequestMap = {
      branch: CusBranchsService.getCusBranchs,
      machine: ProdSetMcsService.getProdSetMcs,
      determine: DefineAgeEquipsService.getDefineAgeEquips
    };

    const serviceRequestFunc = formatSplitKey(key, ".", serviceRequestMap);

    if (serviceRequestFunc) {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: serviceRequestFunc(id),
        callback: (res) => setEditData(res)
      });
    }
  };

  const handleSubmitBinding = (data) => {
    data?.Array.forEach((item, idx) => {
      const modifiedItem = {
        Contract_No: item.Contract_No,
        Contract_Type: item.Contract_Type,
        PM_Per_Year: Number(item.PM_Per_Year),
        Change_Pm_Per_Year: Number(item.Change_Pm_Per_Year),
        Reason_Change_Pm_Per_Year: item.Reason_Change_Pm_Per_Year,
        Item_Id: Number(item.Item_Id),
        Dt_Id: Number(item.Dt_Id),
        Item_Location: item.Item_Location,
        Com_Code: item.Com_Code
      };

      const serviceRequest = item.Id
        ? CustContractItemsService.editCustContractItems(item.Id, modifiedItem)
        : CustContractItemsService.createCustContractItems({
            Array: [modifiedItem]
          });

      addEditServiceRequest({
        showAlert,
        setLoading,
        serviceRequest,
        navigated: (navi) =>
          navi && idx === data?.Array.length - 1 && navigate(0)
      });
    });
  };

  useEffect(() => handleChangeTab(state?.name || "branch"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta
          name="description"
          content="Edit Binding a contract with the product Page"
        />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs justify activeKey={state?.name}>
          <Tab eventKey="branch" title="ผูกสัญญากับสาขา">
            {websiteName === "แก้ไขสินค้าให้สาขา" && (
              <BindContractBranchForm
                editData={editData}
                onSubmitCallback={(data) =>
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: CusBranchsService.editCusBranchs(id, data),
                    navigated: (navi) => navi && navigate(0)
                  })
                }
              />
            )}
          </Tab>
          <Tab eventKey="binding" title="ผูกสัญญากับสินค้า">
            {websiteName === "แก้ไขรายการสินค้าในสัญญา" && (
              <BindingForm onSubmitCallback={handleSubmitBinding} />
            )}
          </Tab>
          <Tab eventKey="machine" title="กำหนดหมายเลขเครื่อง">
            {websiteName ===
              "แก้ไขหมายเลขเครื่องประจำสาขาและเพิ่มรายละเอียดอื่นๆ" && (
              <BranchSerialNumberForm
                editData={editData}
                onSubmitCallback={(data) =>
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: ProdSetMcsService.editProdSetMcs(id, data),
                    navigated: (navi) => navi && navigate(0)
                  })
                }
              />
            )}
          </Tab>
          <Tab eventKey="determine" title="กำหนดอายุอุปกรณ์/อะไหล่">
            {websiteName === "แก้ไขข้อมูลอายุอุปกรณ์/อะไหล่" && (
              <DetermineAgeForm
                editData={editData}
                onSubmitCallback={(data) =>
                  addEditServiceRequest({
                    showAlert,
                    setLoading,
                    serviceRequest: DefineAgeEquipsService.editDefineAgeEquips(
                      id,
                      data
                    ),
                    navigated: (navi) => navi && navigate(0)
                  })
                }
              />
            )}
            {websiteName === "แก้ไขข้อมูล Sticker Date" && (
              <StickerDateForm
                editData={editData}
                onSubmitCallback={(data) =>
                  data?.Array.map(({ Id, ...item }, idx) =>
                    addEditServiceRequest({
                      showAlert,
                      setLoading,
                      serviceRequest:
                        DefineAgeEquipsService.editDefineAgeEquips(id, item),
                      navigated: (navi) =>
                        navi && idx === data?.Array.length - 1 && navigate(0)
                    })
                  )
                }
              />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
